// The chat composer's box: Enter sends (Shift+Enter is a new line), pressing anywhere in it that
// isn't a button puts the caret at the end of the text, the send button doesn't take focus from
// the text, and the attach button opens the form's file input.

export default {
  ChatComposer: {
    mounted() {
      const textarea = () => this.el.querySelector('textarea');

      this.el.addEventListener('keydown', e => {
        if (e.target !== textarea() || e.key !== 'Enter' || e.shiftKey || e.isComposing) return;
        e.preventDefault();

        const submit = this.el.querySelector('button[type=submit]');
        // Text typed before the server enabled the button still sends.
        if (submit && (!submit.disabled || e.target.value.trim())) e.target.form.requestSubmit();
      });

      this.el.addEventListener('mousedown', e => {
        if (e.button !== 0) return;
        if (e.target.closest('button[type=submit]')) return e.preventDefault();
        if (e.target.closest('button, a, input, textarea')) return;

        const text = textarea();
        if (text.disabled) return;
        e.preventDefault();
        text.focus();
        text.setSelectionRange(text.value.length, text.value.length);
      });

      this.el.addEventListener('click', e => {
        if (e.target.closest('[data-attach]')) this.el.closest('form').querySelector('input[type=file]')?.click();
      });
    },
  },
};
